import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LocalStorage } from 'src/utils/local-storage';
import { SessionService } from 'src/services/session.service';
import { DatalayerService } from 'src/services/datalayer.service';
import { AuthService } from 'src/services/auth-services/auth.service';
import { selectRecentsList } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DocumentItem } from 'src/app/document/document-models/document-item';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cps-login-page',
  templateUrl: './cps-login-page.component.html',
  styleUrls: ['./cps-login-page.component.scss']
})
export class CpsLoginPageComponent implements OnInit {
  public loginForm: FormGroup;
  public loginErrorMessage$: BehaviorSubject<string>;

  public recents$: Observable<DocumentItem[]>;
  public userIp$: Observable<string>;

  public isButtonDisabled = false;
  public isLoginHidden = true;
  
  constructor(public translationService: TranslateService, public localStorage: LocalStorage,
    private authService: AuthService,
    private fb: FormBuilder, public sessionService: SessionService,
    private datalayerService: DatalayerService,
    private renderer: Renderer2,
    private store: Store) {

    const thizz = this;
    const params = new Proxy(new URLSearchParams(window.location.search),
      { get: (searchParams, prop) => searchParams.get(prop as string), }
    );

    // If the user is coming from the hub, and will be authenticated, hide the login screen
    const isHideLogin = (params as any).landing;
    if (isHideLogin) {
      this.isLoginHidden = true;
      // fallback to re show the login page
      setTimeout(function () {
        thizz.isLoginHidden = false;
      }, 1000);
    }

    this.validate();
    this.recents$ = this.store.select(selectRecentsList);
  }

  validate(): void {
    this.loginForm = this.fb.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      rememberMe: [false]     
    });
  }

  ngOnInit(): void {
    const params = new Proxy(new URLSearchParams(window.location.search),
      { get: (searchParams, prop) => searchParams.get(prop as string), }
    );
    const pParam = (params as any).p;
    const rParam = (params as any).r;

    // For p param and autologin by post (rParam) logins, redirect them to the hub
    // and let the login page there handle the authentication
    if (pParam !== null || rParam !== null) {
      const authToken = pParam !== null ? pParam : rParam;
      this.redirectToHub(authToken);
    } else if (this.datalayerService.getLastLogEvent() !== "logout") {  //DIG-2965 This condition was added to avoid getting a new token by IP when doing 'logout'. 
      // HUB-110 IP logins are now handled after the redirect to hub
      //this.authService.setIpAuthenticatedUserDetails();
    }

    if (!pParam && !rParam) {
      // HUB-110 Redirect everyone from the login page to the hub login
      this.redirectToHub(null);
    }

    /* Old login logic, keeping it in here in case we'll need the CPS login again
    window.scrollTo(0, 0);
    this.authService.requestCompletion$.subscribe(completed => {
      if (completed) {
        this.isButtonDisabled = false;
        this.authService.setRequestCompletionState(false);
      }
    });
    
    this.userIp$ = this.authService.getIpCheckMessage();

    this.datalayerService.pageLoadEvent('login', 'Login Page');

    const urlParams = window.location.search;

    if (urlParams) { 
      if (urlParams.includes('error=AccountExpired')) {
        this.authService.setLoginErrorMessage('error.authentication.code.2');
      }
      else if (urlParams.includes('error=401')) {
        this.authService.setLoginErrorMessage('error.authentication.code.1');
      }
      else {
        this.authService.setLoginErrorMessage('error.authentication.code.1');
      }
    }

    this.loginErrorMessage$ = this.authService.getLoginErrorMessage();
    */
  }

  rememberMe(): void {
    console.log('Remember Me');
  }

  get f() {
    return this.loginForm.controls;
  }

  tabUser(): void {
    this.renderer.selectRootElement('#password').focus();
  }

  login(): void {
    this.loginForm.markAllAsTouched();
    this.isButtonDisabled = true;
    
    if (this.loginForm.invalid) {
      this.authService.setLoginErrorMessage('error.authentication.code.1');
      this.loginErrorMessage$ = this.authService.getLoginErrorMessage();
      this.isButtonDisabled = false;
      return;
    }

    this.authService.setIsUserAuthenticated(this.isButtonDisabled);
    this.authService.setUserCredentials(this.f.username.value, this.f.password.value);
    this.loginErrorMessage$ = this.authService.getLoginErrorMessage();
    console.log(this.loginErrorMessage$); 
  }

  redirectToHub(pParam: string): void {
    let params = '?lang=' + this.translationService.currentLang;
    if (pParam !== null) {
      params += '&p=' + pParam;
    }
    window.location.href = environment.HUB_ENDPOINT + params;
  }
}